
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.rwd_menu = {
    attach: function (context, settings) {

    }
  };

  $(document).ready(function(){
    if (window.matchMedia) {
      var rwdMenu = window.matchMedia("(max-width: 1349px)");
      rwdMenu.addListener(handleMenu);
      handleMenu(rwdMenu);
    }
  });

  function handleMenu(rwdMenu){
    if(rwdMenu.matches) {
      display_menu_mobile();
    }else{
      display_menu_normal();
    }
  }

  function display_menu_mobile(){
    create_mmenu();
    $('.mmenu .mmenu__inner').append($('.region--header-top .search-form--views-block'));

    $('.mmenu .mmenu__inner').append($('.region--header-bottom .main-menu--menu-block'));
    $('.mmenu .mmenu__inner').append($('.region--header-top .secondary-menu--menu-block'));

    $('.mmenu .mmenu__inner').append($('.region--header-top .language-switcher--block'));
    // $('.mmenu .mmenu__inner').append($('.region--header-top .color-scheme-selector--block'));

    create_mmenu_submenu_togglers();

    $('.mmenu .menu__item a').click(function(e){
      $('.mmenu').removeClass('active');
      $('.mmenu_toggler').removeClass('active');
    });
  }

  function display_menu_normal(){
    $('.mmenu .submenu-toggler').remove();

    $('.page_header .region--header-bottom').append($('.mmenu .mmenu__inner .main-menu--menu-block'));

    $('.page_header .region--header-top').append($('.mmenu .mmenu__inner .search-form--views-block'));
    $('.page_header .region--header-top').append($('.mmenu .mmenu__inner .secondary-menu--menu-block'));
    $('.page_header .region--header-top').append($('.mmenu .mmenu__inner .language-switcher--block'));
    // $('.page_header .region--header-top').append($('.mmenu .mmenu__inner .color-scheme-selector--block'));
    remove_mmenu();
  }

  function create_mmenu(){
    $('body').append("<div class='mmenu'><div class='mmenu__inner'></div></div>");
    $('.page_header .region--header-bottom').append("<div class='mmenu_toggler'><span></span><span></span><span></span></div");

    $('.mmenu_toggler').click(function(e){
      e.preventDefault();
      $('.mmenu').toggleClass('active');
      $(this).toggleClass('active');
    })
  }

  function create_mmenu_submenu_togglers(){
    $('.mmenu .mmenu__inner .contains-submenu').append("<span class='submenu-toggler'><span></span></span>");
    $('.mmenu .submenu-toggler').click(function(e){
      e.preventDefault();
      $(this).parent().toggleClass('menu__item--active');
    });
  }

  function remove_mmenu(){
    $('.mmenu').remove();
    $('.mmenu_toggler').remove();
  }


})(jQuery, Drupal);
